import React from 'react';
import { Box, Divider, Skeleton } from '@mui/material';

const ServeOrderCardSkeleton = () => {
  return (
    <Box
      sx={{
        bgcolor: '#fff',
        borderRadius: 2,
        border: '1px solid #BDBDBD',
        p: 1,
      }}
    >
      {/* header: order no + time */}
      <Box className="d-flex align-items-center justify-content-between">
        <Skeleton variant="text" width={60} height={20} animation="wave" />
        <Skeleton variant="text" width={45} height={20} animation="wave" />
      </Box>

      {/* item + qty */}
      <Box sx={{ my: 0.5 }}>
        <Box className="d-flex align-items-center justify-content-between">
          <Skeleton variant="text" width="60%" height={24} animation="wave" />
          <Skeleton variant="text" width={28} height={24} animation="wave" />
        </Box>

        <Divider sx={{ borderColor: '#D9D9D9', my: 1 }} />

        {/* table / type + action arrows */}
        <Box className="d-flex align-items-start justify-content-between">
          <Skeleton variant="text" width={65} height={20} animation="wave" />
          <Box className="d-flex align-items-center" sx={{ gap: 1 }}>
            <Skeleton variant="circular" width={18} height={18} animation="wave" />
            <Skeleton variant="circular" width={18} height={18} animation="wave" />
          </Box>
        </Box>

        {/* station / chef */}
        <Box sx={{ mt: 1 }}>
          <Skeleton variant="text" width="50%" height={20} animation="wave" />
        </Box>
      </Box>
    </Box>
  );
};

export default ServeOrderCardSkeleton;
